import { type Size } from '@atlaskit/icon';

import { type AvatarSize } from './types';

export const DIMENSIONS: Record<AvatarSize, number> = {
	xsmall: 2,
	small: 3,
	medium: 4,
	large: 5,
};

export const ICON_SIZE_MAPPER: Record<AvatarSize, Size> = {
	xsmall: 'small',
	small: 'medium',
	medium: 'large',
	large: 'xlarge',
};
